import { Spinner } from '@/components/commons/Spinner';

/**
 * Link component
 */
interface IProps {
  label: string;
  disabled?: boolean;
  type?: 'submit' | 'button';
  isSpinning?: boolean;
  onClick?: () => void;
  size?: 'large' | 'small';
  className?: string;
  id?: string;
  style?: object;
}

export const Button = (
  {
    label,
    disabled,
    type,
    isSpinning,
    onClick,
    size,
    className,
    style,
    id,
  }: IProps = {
    label: '',
    disabled: false,
    type: 'button',
    isSpinning: false,
    onClick: () => null,
    className: '',
    style: {},
  },
) => {
  const classes = ['tw-button', 'tw-btn-primary', 'tw-mt-0', 'tw-mb-0'];

  if (size === 'small') {
    classes.push('tw-btn-sm');
  } else if (size === 'large') {
    classes.push('tw-btn-lg');
  } else {
    classes.push('tw-btn-md');
  }

  return (
    <button
      id={id}
      disabled={disabled}
      className={classes.join(' ') + ' ' + className}
      type={type}
      style={style}
      {...(onClick && { onClick })}
    >
      {label}
      {isSpinning && <Spinner size='small' className="tw-ml-2"/>}
    </button>
  );
};
